import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CollapsibleHeadings = _resolveComponent("CollapsibleHeadings")
  const _component_HtmlMapper = _resolveComponent("HtmlMapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.collapsibleHeadings)
      ? (_openBlock(), _createBlock(_component_CollapsibleHeadings, {
          key: 0,
          restricted: $props.restricted,
          nodes: $options.nodes,
          "default-expanded": $props.headingsExpanded
        }, null, 8 /* PROPS */, ["restricted", "nodes", "default-expanded"]))
      : (_openBlock(), _createBlock(_component_HtmlMapper, {
          key: 1,
          restricted: $props.restricted,
          nodes: $options.nodes
        }, null, 8 /* PROPS */, ["restricted", "nodes"]))
  ]))
}